import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { useMediaQuery } from '@mui/material';
import cn from 'classnames';
import { FC, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import { CustomButton, Icon } from '../../../../components';
import { formattedDate } from '../../../../utils/string/toLocaleDateString';
import CommentForm from '../CommentForm';
import { ICommentChildrenResponse } from '../comment.interface';

import styles from './CommentItem.module.sass';
import { useCommentItem } from './useCommentItem';

export interface ICommentItem {
  comment: ICommentChildrenResponse;
  isAnswerBtn?: boolean;
  level?: number;
  isCommentBtn?: boolean;
}
const CommentItem: FC<ICommentItem> = ({
  comment,
  isCommentBtn,
  level = 1,
}) => {
  const { commentItem, action } = useCommentItem(comment);
  const paddingLeft = level > 1 ? '15px' : '0';
  const isLike = comment.is_like_by_me === true ? 'blue' : 'gray';
  const isDislike = comment.is_like_by_me === false ? 'blue' : 'gray';
  const mobileScreen = useMediaQuery('(min-width:540px)');
  const [isOpen, setIsOpen] = useState(false);
  function toggleOpen() {
    setIsOpen(!isOpen);
  }
  return (
    <div className={styles.block}>
      <div className={styles.container}>
        <div className={styles.item}>
          <div className={styles.header}>
            <h3 className={styles.avatar}>П</h3>
            <div className={styles.information}>
              <div className={styles.name}>{comment.user_firstname}</div>
              <div className={styles.date}>
                {formattedDate(comment.created_at)}
              </div>
            </div>
          </div>
          <div className={styles.text}>{comment.content}</div>
          <div className={styles.actions}>
            <div className={styles.buttons}>
              <CustomButton variant={isLike} onClick={action.onSetLike}>
                <Icon variant="like" />
                {comment.likes_count}
              </CustomButton>
              <CustomButton variant={isDislike} onClick={action.onSetDislike}>
                <Icon variant="dislike" />
                {comment.dislikes_count}
              </CustomButton>
            </div>
            <div className={styles.right}>
              <div className={styles.answer} onClick={action.onShowCommentForm}>
                Ответить
              </div>
              {/*              {isCommentBtn && (
                <div className={styles.commentsWrapper}>
                  <div className={styles.comments} onClick={onShowComments}>
                    <p className={styles.text}>Комментарии</p>
                    {showComments ? (
                      <ExpandLessRoundedIcon />
                    ) : (
                      <ExpandMoreRoundedIcon />
                    )}
                  </div>
                </div>
              )}*/}
              {comment.children.length >= 1 && (
                <div className={styles.commentsWrapper}>
                  <div className={styles.comments} onClick={toggleOpen}>
                    <p className={styles.text}>
                      Комментарии ({comment.children.length})
                    </p>
                    {isOpen ? (
                      <ExpandLessRoundedIcon />
                    ) : (
                      <ExpandMoreRoundedIcon />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <CSSTransition
          in={commentItem.showItemCommentForm}
          classNames="comment-animation"
          timeout={300}
          unmountOnExit
        >
          <CommentForm />
        </CSSTransition>
      </div>
      {isOpen && comment?.children?.length
        ? comment.children?.map((item: any, i) => {
            return (
              <div className={cn(styles.wrapper)}>
                <div
                  className={styles.lists}
                  style={{
                    paddingLeft: paddingLeft,
                  }}
                >
                  <CommentItem key={item.id} comment={item} level={level + 1} />
                </div>
              </div>
            );
          })
        : null}
    </div>
  );
};

export default CommentItem;
